<section class="wrapper">
  <div class="container">
    <h2 class="title-h2">
      <a (click)="navigateBackPage()" class="text-inherit mr-2"
        ><i class="fa fa-long-arrow-left"></i>
      </a>
      <ng-container *ngIf="!contactValue.isEditPage"
        >Add Trusted Contacts
      </ng-container>
      <ng-container *ngIf="contactValue.isEditPage"
        >Edit Trusted Contacts</ng-container
      >
    </h2>
    <p>
      You can add maximum 3 contacts in your emergency trusted contact list
    </p>

    <form class="form-w" [formGroup]="contactForm" (ngSubmit)="addContact()">
      <div class="row mt-4">
        <div class="col-lg-3 col-sm-6">
          <!-- <div class="form-group">
            <label>Name</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter Name"
              formControlName="name"
              [ngClass]="{
                'is-invalid':
                  (submitted || (f.name.touched && !f.name.valid)) &&
                  f.name.errors
              }"
            />
            <div
              *ngIf="(submitted || f.name.touched) && f.name.errors"
              class="invalid-feedback"
            >
              <div *ngIf="f.name.errors.required">Please Enter name</div>
            </div>
          </div> -->

          <div class="form-group">
            <label>Name</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter Name"
              formControlName="name"
              [ngClass]="{
                'is-invalid':
                  (submitted || (f.name.touched && !f.name.valid)) &&
                  f.name.errors
              }"
            />

            <div
              *ngIf="(submitted || f.name.touched) && f.name.errors"
              class="invalid-feedback"
            >
              <!-- 
          Prioritize the required error message. 
          If 'required' is present, only show that message. 
        -->
              <div *ngIf="f.name.errors.required">Name is required</div>

              <!-- 
          If 'required' is NOT present, but 'whitespace' is, show the whitespace message.
        -->
              <div *ngIf="!f.name.errors.required && f.name.errors.whitespace">
                Name cannot be just whitespace
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="form-group">
            <label>Email</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter email"
              formControlName="email"
              [ngClass]="{
                'is-invalid':
                  (submitted || (f.email.touched && !f.email.valid)) &&
                  f.email.errors
              }"
            />
            <div
              *ngIf="(submitted || f.email.touched) && f.email.errors"
              class="invalid-feedback"
            >
              <div *ngIf="f.email.errors.required">Please Enter Email</div>
              <!-- This div handles the new regex pattern error -->
              <div *ngIf="f.email.errors.pattern">
                Please enter a valid email address (e.g., name@domain.com)
              </div>
            </div>
            <!-- <div
              *ngIf="(submitted || f.email.touched) && f.email.errors"
              class="invalid-feedback"
            >
              <div *ngIf="f.email.errors.required">Please Enter Email</div>
              <div *ngIf="f.email.errors.email">
                Email must be a valid email address
              </div>
            </div> -->
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="form-group">
            <label>Mobile Number</label>
            <input
              type="text"
              class="form-control"
              appPhoneMask
              (keypress)="cmnFunction.keyPress($event)"
              placeholder="Enter Mobile Number"
              minlength="14"
              maxlength="14"
              formControlName="mobileNumber"
              [ngClass]="{
                'is-invalid':
                  (submitted ||
                    (f.mobileNumber.touched && !f.mobileNumber.valid)) &&
                  f.mobileNumber.errors
              }"
            />
            <div
              *ngIf="
                (submitted || f.mobileNumber.touched) && f.mobileNumber.errors
              "
              class="invalid-feedback"
            >
              <div *ngIf="f.mobileNumber.errors.required">
                Mobile Number is required
              </div>
              <div *ngIf="f.mobileNumber.errors.minlength">
                Enter Minimum 10 digit mobile number
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="form-group mt-sm-2">
            <button
              type="submit"
              class="btn btn-primary mt-sm-4"
              [disabled]="isLoadingData"
            >
              <span *ngIf="isLoadingData">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </span>
              <ng-container *ngIf="!contactValue.isEditPage"
                >Add Now</ng-container
              >
              <ng-container *ngIf="contactValue.isEditPage"
                >Update</ng-container
              >
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
